import { Button } from "antd";

export default function Header({ logout }) {
  return (
    <div className="header">
      <h2>Financly Dashboard</h2>
      <Button onClick={logout}>Logout</Button>
    </div>
  );
}